// ── Hero Slide Video Controls & Lightbox (Event Delegation) ───────────────────
(function() {
    function sendYoutubeCommand(iframe, func, args = '') {
        try {
            iframe.contentWindow.postMessage(JSON.stringify({
                event: 'command',
                func: func,
                args: args
            }), '*');
        } catch (e) {
            console.error('Error sending message to YouTube iframe:', e);
        }
    }

    document.addEventListener('click', function(e) {
        // 1. Mute Button OR Slide Click Handler
        const lightboxBtnClick = e.target.closest('.lightbox-btn');
        const muteTarget = e.target.closest('.mute-btn') || e.target.closest('.home-hero__slide.has-video');

        if (muteTarget && !lightboxBtnClick) {
            e.stopPropagation();
            e.preventDefault();

            const slide = muteTarget.closest('.home-hero__slide');
            if (!slide) return;
            const muteBtn = slide.querySelector('.mute-btn');
            if (!muteBtn) return;

            const video = slide.querySelector('video');
            const iframe = slide.querySelector('iframe');
            const iconMute = muteBtn.querySelector('.icon-mute');
            const iconUnmute = muteBtn.querySelector('.icon-unmute');

            // Track state on dataset
            let isMuted = muteBtn.dataset.muted !== 'false'; // default is true
            isMuted = !isMuted;

            // If we are unmuting this video, mute all other playing videos first
            if (!isMuted) {
                const allMuteBtns = document.querySelectorAll('.home-hero__slide .mute-btn');
                allMuteBtns.forEach(btn => {
                    if (btn !== muteBtn && btn.dataset.muted === 'false') {
                        btn.dataset.muted = 'true';
                        
                        const otherSlide = btn.closest('.home-hero__slide');
                        if (otherSlide) {
                            const otherVideo = otherSlide.querySelector('video');
                            const otherIframe = otherSlide.querySelector('iframe');
                            
                            if (otherVideo) {
                                otherVideo.muted = true;
                            } else if (otherIframe) {
                                sendYoutubeCommand(otherIframe, 'mute');
                            }
                        }

                        // Update icons on other buttons
                        const otherMuteIcon = btn.querySelector('.icon-mute');
                        const otherUnmuteIcon = btn.querySelector('.icon-unmute');
                        if (otherMuteIcon) otherMuteIcon.style.display = 'block';
                        if (otherUnmuteIcon) otherUnmuteIcon.style.display = 'none';
                    }
                });
            }

            muteBtn.dataset.muted = isMuted;

            if (video) {
                video.muted = isMuted;
            } else if (iframe) {
                sendYoutubeCommand(iframe, isMuted ? 'mute' : 'unMute');
            }

            // Update UI Icons
            if (isMuted) {
                if (iconMute) iconMute.style.display = 'block';
                if (iconUnmute) iconUnmute.style.display = 'none';
            } else {
                if (iconMute) iconMute.style.display = 'none';
                if (iconUnmute) iconUnmute.style.display = 'block';
            }
            return;
        }

        // 2. Lightbox Button Click Handler
        const lightboxBtn = e.target.closest('.lightbox-btn');
        if (lightboxBtn) {
            e.stopPropagation();
            e.preventDefault();

            const slide = lightboxBtn.closest('.home-hero__slide');
            if (!slide) return;
            const videoSrc = slide.getAttribute('data-video-src');
            if (!videoSrc) return;

            // Get all unique video sources
            const allSlides = Array.from(document.querySelectorAll('.home-hero__slide.has-video'));
            const uniqueVideos = [];
            allSlides.forEach(s => {
                const src = s.getAttribute('data-video-src');
                if (src && !uniqueVideos.includes(src)) {
                    uniqueVideos.push(src);
                }
            });
            
            let currentIndex = uniqueVideos.indexOf(videoSrc);
            if (currentIndex === -1) currentIndex = 0;

            // Create Lightbox Container
            const lightbox = document.createElement('div');
            lightbox.className = 'home-hero__lightbox';
            
            lightbox.innerHTML = `
                <button class="home-hero__lightbox-close" aria-label="Close Lightbox">&times;</button>
                <button class="home-hero__lightbox-prev" aria-label="Previous Video">&#10094;</button>
                <button class="home-hero__lightbox-next" aria-label="Next Video">&#10095;</button>
                <div class="home-hero__lightbox-content"></div>
            `;

            const contentBox = lightbox.querySelector('.home-hero__lightbox-content');
            const prevBtn = lightbox.querySelector('.home-hero__lightbox-prev');
            const nextBtn = lightbox.querySelector('.home-hero__lightbox-next');

            function loadVideo(index) {
                const vSrc = uniqueVideos[index];
                if (!vSrc) return;

                if (vSrc.includes('youtube.com') || vSrc.includes('youtu.be')) {
                    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|shorts\/)([^#\&\?]*).*/;
                    const match = vSrc.match(regExp);
                    const youtubeId = (match && match[2].length === 11) ? match[2] : null;

                    if (youtubeId) {
                        contentBox.innerHTML = `
                            <iframe src="https://www.youtube.com/embed/${youtubeId}?autoplay=1&mute=0&controls=1&rel=0&playsinline=1" 
                                    frameborder="0" 
                                    allow="autoplay; encrypted-media" 
                                    allowfullscreen></iframe>
                        `;
                    } else {
                        contentBox.innerHTML = '<div style="color: #fff; padding: 20px;">Video not found</div>';
                    }
                } else {
                    contentBox.innerHTML = `
                        <video src="${vSrc}" autoplay controls playsinline></video>
                    `;
                }
            }

            loadVideo(currentIndex);

            if (uniqueVideos.length <= 1) {
                prevBtn.style.display = 'none';
                nextBtn.style.display = 'none';
            } else {
                prevBtn.addEventListener('click', function(evt) {
                    evt.stopPropagation();
                    currentIndex = (currentIndex - 1 + uniqueVideos.length) % uniqueVideos.length;
                    loadVideo(currentIndex);
                });
                
                nextBtn.addEventListener('click', function(evt) {
                    evt.stopPropagation();
                    currentIndex = (currentIndex + 1) % uniqueVideos.length;
                    loadVideo(currentIndex);
                });
            }

            document.body.appendChild(lightbox);
            document.body.classList.add('lightbox-open');

            setTimeout(() => {
                lightbox.classList.add('is-active');
            }, 10);

            function closeLightbox() {
                lightbox.classList.remove('is-active');
                document.body.classList.remove('lightbox-open');
                setTimeout(() => {
                    lightbox.remove();
                }, 300);
            }

            lightbox.querySelector('.home-hero__lightbox-close').addEventListener('click', closeLightbox);
            lightbox.addEventListener('click', function(evt) {
                if (evt.target === lightbox) {
                    closeLightbox();
                }
            });
        }
    });
})();

document.addEventListener('DOMContentLoaded', function() {
    var wrapper = document.querySelector('.animated-words-wrapper');
    if (!wrapper) return;

    var wordsJson = wrapper.getAttribute('data-words');
    var words = [];
    try {
        words = JSON.parse(wordsJson);
    } catch(e) {
        console.error('Failed to parse animated words', e);
        return;
    }

    if (!words || words.length <= 1) return;

    var isTypewriter = wrapper.classList.contains('animation-typewriter');
    var currentIndex = 0;

    if (isTypewriter) {
        var wordEl = wrapper.querySelector('.animated-word');
        if (!wordEl) return;
        
        var text = wordEl.textContent || '';
        var isDeleting = false;
        var typingSpeed = 120;

        function type() {
            var fullWord = words[currentIndex];
            
            if (isDeleting) {
                text = fullWord.substring(0, text.length - 1);
                typingSpeed = 60;
            } else {
                text = fullWord.substring(0, text.length + 1);
                typingSpeed = 140;
            }

            wordEl.textContent = text;

            if (!isDeleting && text === fullWord) {
                // Pause at complete word
                typingSpeed = 2200;
                isDeleting = true;
            } else if (isDeleting && text === '') {
                isDeleting = false;
                currentIndex = (currentIndex + 1) % words.length;
                typingSpeed = 500; // Pause before typing the next word
            }

            setTimeout(type, typingSpeed);
        }

        // Start typing after initial delay
        setTimeout(type, 1200);

    } else {
        var wordEls = wrapper.querySelectorAll('.animated-word');
        if (wordEls.length <= 1) return;

        setInterval(function() {
            var activeEl = wrapper.querySelector('.animated-word.active');
            var nextIndex = (currentIndex + 1) % wordEls.length;
            var nextEl = wordEls[nextIndex];

            if (activeEl && nextEl) {
                activeEl.classList.remove('active');
                activeEl.classList.add('outgoing');
                
                nextEl.classList.add('active');
                currentIndex = nextIndex;

                // Remove outgoing class after animation transition completes
                setTimeout(function() {
                    activeEl.classList.remove('outgoing');
                }, 600);
            }
        }, 5000);
    }
});
